import React from 'react';
import { Table, Button } from 'semantic-ui-react';
import { useDeleteSpecial } from '~/groupings';

const isPercent = num => num % 1 !== 0;

const toNum = num => num * 100;

const parcePrice = special => {

    if (!special) {
        return 'N/A';
    }

    if (isPercent(special)) {

        return `${toNum(special)}%`;
    }

    return `$${special}`;

};

const SpecialsTable = props => {


    const {
        specials,
        setInitialValues,
        setSpecialsModalOpen,
        propertyId
    } = props;

    const { mutate: deleteSpecial } = useDeleteSpecial();

    return (
        <Table columns={3} fixed size='small'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell> Name </Table.HeaderCell>
                    <Table.HeaderCell> Discount </Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'> Actions </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {specials.map((group, i) => (
                    <Table.Row key={`group-${i}`}>
                        <Table.Cell content={group.name} />
                        <Table.Cell content={parcePrice(group.special)} />
                        <Table.Cell textAlign='right'>
                            <Button.Group>

                                <Button
                                    compact
                                    content='Edit'
                                    icon='edit'
                                    onClick={() => {
                                        setInitialValues(group);
                                        setSpecialsModalOpen(true);
                                    }}
                                />
                                <Button
                                    compact
                                    negative
                                    content='Delete'
                                    icon='delete'
                                    onClick={() => {
                                        deleteSpecial(group.id);
                                    }}
                                />
                            </Button.Group>
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell colSpan='3' textAlign='right'>
                        <Button
                            compact
                            primary
                            content='New Special'
                            onClick={() => {
                                setInitialValues({ property_id: propertyId });
                                setSpecialsModalOpen(true);
                            }}/>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
    );
};

export default SpecialsTable;
